import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import { MarketplaceState } from '../marketplace-model'

export const createInitialState = (): MarketplaceState => ({
  marketplaceOrders: [],
  pagination: {
    totalCount: 0,
    pageNumber: 1,
    nextPageNumber: null,
    previousPageNumber: null
  },
  filters: {},
  lastRefreshed: null,
  updatedSinceLastRefresh: [],
  updates: [],
  nextLoadSuggestions: []
})

export default {
  state: createInitialState(),
  getters,
  mutations,
  actions
}
